import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Heading, Subhead } from 'rebass';
import styled from 'styled-components';
import Paragraph from './paragraph';
import GoBack from './go_back';
import Tags from './tags';

const Container = styled(Box)`
  position: relative;
`;

const Details = ({ title, subtitle, children, withGoBack }) => (
  <Container
    pt={[0, 3]}
    px={[3, 5]}
    pb={[4, 6]}
  >
    <Box
      px={[2, 0]}
      pt={5}
    >
      {
        (title || subtitle) &&
          <Flex
            mb={[4, 6]}
            justify="center"
            column
          >
            {
              title &&
                <Heading is="h1" f={[5, 5, 6]}>
                  {title}
                </Heading>
            }
            {
              subtitle &&
                <Subhead
                  is="h2"
                  f={[2, 2, 3]}
                  color="grey"
                >
                  {subtitle}
                </Subhead>
            }
          </Flex>
      }
      {children}
    </Box>
    {withGoBack && <GoBack />}
  </Container>
);

Details.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  withGoBack: PropTypes.bool,
};

Details.defaultProps = {
  title: null,
  subtitle: null,
  children: null,
  withGoBack: true,
};

Details.Paragraph = Paragraph;
Details.Tags = Tags;

export default Details;



// WEBPACK FOOTER //
// ./src/Details/index.js